var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAlertInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9.8 22.79",
    "aria-labelledby": "alertInfoIcon alertInfoDesc"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M7.86 9.73L5.24 22.79H0L3.28 6.38h4.58m0-2.1H3.71L4.56 0h3.3"
  })));
}

export default SvgIconAlertInfo;